export default [
    {
        path: '/accounts',
        name: 'Company / User Accounts',
        component: () => import('@/views/pages/accounts'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'create',
                name: 'Create Branch / User Account',
                component: () => import('@/views/pages/accounts'),
                meta:
                {
                    name: 'Create User Account',
                    page: 'create',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'View Branch / User Account',
                component: () => import('@/views/pages/accounts'),
                meta:
                {
                    name: 'View User Account',

                    page: 'view',
                },
                children:
                [
                    {
                        path: 'edit',
                        name: 'Edit Branch / User Account',
                        component: () => import('@/views/pages/accounts'),
                        meta:
                        {
                            name: 'Edit User Account',

                            page: 'edit',
                            subPage: 'main',
                        },
                    },
                ],
            },
        ],
    },
];